import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import axios from "axios";

const API = "https://api.recoverymatch.com";

/**
 * AuthCallback Component
 * Handles the OAuth redirect and session exchange
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace("#", ""));
      const sessionId = params.get("session_id");

      if (!sessionId) {
        console.error("No session_id found in URL");
        navigate("/login");
        return;
      }

      try {
        // Exchange session_id for user data
        const response = await axios.post(
          `${API}/api/auth/google/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );

        const { token, user, is_new_user } = response.data;

        // Store JWT token for existing auth system compatibility
        localStorage.setItem("token", token);
        
        // Update auth context
        setUser(user);

        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);

        // Redirect based on profile completion
        if (is_new_user || !user.profile_complete) {
          navigate("/setup", { replace: true });
        } else {
          navigate("/matches", { replace: true });
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        navigate("/login", { replace: true });
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-4">
          <img 
            src="/images/logo-main.png" 
            alt="RecoveryMatch" 
            className="w-full h-full rounded-xl animate-pulse"
          />
        </div>
        <div className="animate-spin rounded-full h-8 w-8 border-4 border-[#FAB710] border-t-transparent mx-auto mb-4"></div>
        <p className="text-gray-600">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
